import './App.css'
import React from "react";
import { useLocation } from "react-router-dom";

const Generate =()=>{
    const location = useLocation();
    const{name, mail, dept, textA,image,links}= location.state || {};
    
    return (
        <div className="Generate">
            
            <p className='Labels'>
                <strong>Name:</strong>{name}
                <br></br>
                <strong> Email:</strong> {mail}
                <br></br>
                <strong>Department:</strong>{dept}
                <br></br>
                <strong>additional comments:</strong>{textA}
                <br></br>
                Project Links: 
                <ul className='Links'>
                    {links && links.map((link, index) => (
                        <li key={index}>{
                            <a href={link} target='_blank' rel='nooppener noreferrer'>{link}</a>
                        }</li>
                    ))}
                </ul>
            </p> 
            Profile image {image && (
                <div>
                    <img src={URL.createObjectURL(image)} width='500px' height='400px' alt='img'/>
                </div>

            )}
        </div>
    );
}

export default Generate;